// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js??ref--9-1!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/lib/index.js??ref--9-2!../../node_modules/sass-loader/lib/loader.js??ref--9-3!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AbstractPaginaGestione.vue?vue&type=style&index=0&id=7e15f876&lang=sass&scoped=true");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("7cb1531a", content, true, {});